<div>
  <mat-dialog-content>
    <div class="w-100 text-center primary-color mb-3 text-bold">{{title}}</div>
    <mat-accordion>
      @if (needsFinancialAuthorization) {
        <mat-expansion-panel [disabled]="hasFinancialAuthorization" [hideToggle]="financialAuthorizationExpanded" [expanded]="financialAuthorizationExpanded">
          <mat-expansion-panel-header>
            <mat-panel-title><span class="flex-row">@if (hasFinancialAuthorization) {
                <mat-icon class="green-color">done</mat-icon>
              }
              @else {
                <mat-icon class="red-color">priority_high</mat-icon>
              }
              <h3 class="text-muted">Credit Card Authorization</h3></span></mat-panel-title>
            </mat-expansion-panel-header>
            <app-authorization-stripe (onAuthorizationExecuted)="financialAuthorizationExecuted($event)"></app-authorization-stripe>
          </mat-expansion-panel>
        }
        @if (needsPrePurchaseAgreement) {
          <mat-expansion-panel [disabled]="hasPrePurchaseAgreement" [hideToggle]="prePurchaseAgreementExpanded" [expaned]="prePurchaseAgreementExpanded">
            <mat-expansion-panel-header>
              <mat-panel-title><span class="flex-row">@if (hasPrePurchaseAgreement) {
                <mat-icon class="green-color">done</mat-icon>
                }
                @else {
                  <mat-icon class="red-color">priority_high</mat-icon>
                }
                <h3 class="text-muted">Execute Purchase Agreement</h3></span></mat-panel-title>
                @if (hasPrePurchaseAgreement) {
                  <mat-icon-button class="primary-color" matTooltip="Download Agreement" (click)="onDownloadAgreementClick()"><mat-icon>download</mat-icon></mat-icon-button>
                }
              </mat-expansion-panel-header>
              <app-buyer-legal-document [documentTemplate]="documentTemplate" [internal]="false" (onDocumentExecuted)="legalDocumentExecuted($event)"></app-buyer-legal-document>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </mat-dialog-content>
      <mat-dialog-actions>
        <div class="flex-row space-between items-center w-100 mt-3 p-2">
          <button mat-flat-button class="w-100 neutral-button" (click)="onCancelClick()" >{{cancelButtonText}}</button>
        </div>
      </mat-dialog-actions>
    </div>


